import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import './index.css'
import './fonts/wotfard-medium-webfont.woff2'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorkerRegistration.register()

window.addEventListener('beforeinstallprompt', function (e) {
  e.preventDefault()
  return false
})
